module.exports = __webpack_public_path__ + "img/img_stgl2.f36ecf24.png";